define('question_collection.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('question_collection', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div data-type=\"backbone.collection.view.rows\"></div>";
},"useData":true}, 'extensions/TavanoteamSEO/QAndA/1.0.4/', 'extensions/TavanoteamSEO/QAndA/1.0.4/', Handlebars);
});